module.exports = __webpack_public_path__ + "img/page-header-background-circle.0d1449f5.svg";